import type {
  ApiTokenView,
  CreatedApiToken,
  CreateApiTokenInput,
} from '@logspot-platform/platform-types';
import { api } from './api-client';

type Envelope<T> = { data: T };

// Org-owned API Tokens (`sk_`). Backend routes live at /api/api-tokens
// (owner/admin only). Project-scoped tokens carry resourceScope.projectIds.
export const ApiTokensService = {
  list: async (): Promise<ApiTokenView[]> => {
    const res = await api.get<Envelope<ApiTokenView[]>>('/api-tokens');
    return res.data;
  },
  create: async (input: CreateApiTokenInput): Promise<CreatedApiToken> => {
    const res = await api.post<Envelope<CreatedApiToken>>('/api-tokens', input);
    return res.data;
  },
  revoke: async (id: string): Promise<void> => {
    await api.delete(`/api-tokens/${id}`);
  },
};
